import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchAlertDefinitionsList } from '@/domains/alert-definitions/alert-definitions.api';

export const alertDefinitionsQueryKeys = createQueryKeys('alertDefinitions', {
  list: () => ({
    queryKey: [{}],
    queryFn: () => fetchAlertDefinitionsList(),
  }),
});
